export const ALL_VALUES = 'All'
export const SELECT_ALL_ITEM = { label: ALL_VALUES, value: '0' }
export const MIN_ITEM_COUNT_FOR_SEARCH = 5

export const EMPTY_ITEM = { label: '', value: '' }

export const NOT_FOUND = 'Not found'
